/**
 * Attend un nombre donné de millisecondes.
 * @param ms Temps d'attente en millisecondes.
 */
// eslint-disable-next-line import/prefer-default-export
export const sleep = (ms: number): Promise<void> =>
    new Promise((resolve) => {
        setTimeout(resolve, ms);
    });